import { render, staticRenderFns } from "./assistance-choice-box.component.vue?vue&type=template&id=30ff1cbc&"
import script from "./assistance-choice-box.component.vue?vue&type=script&lang=ts&"
export * from "./assistance-choice-box.component.vue?vue&type=script&lang=ts&"
import style0 from "./assistance-choice-box.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistance-choice-box.component.vue"
export default component.exports